import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8a886caa&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=8a886caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a886caa",
  null
  
)

export default component.exports